// @flow
import * as React from 'react'
import Grid, { GridCell } from 'ui/Grid'
import SectionHeading from './SectionHeading'

type Props = {
  actions?: React.Node,
  title?: React.Node,
}

export default class SectionStandardHeading extends React.Component<Props> {
  render = () => {
    return (
      <SectionHeading>
        <Grid justifyContent="space-between" alignItems="flex-end">
          {this.renderTitleMaybe()}
          {this.renderActionsMaybe()}
        </Grid>
      </SectionHeading>
    )
  }

  renderTitleMaybe = () => {
    if (!this.props.title) return null
    return <GridCell>{this.props.title}</GridCell>
  }

  renderActionsMaybe = () => {
    if (!this.props.actions) return null
    return (
      <GridCell flex="none">
        <div className="Section-headingActions">{this.props.actions}</div>
      </GridCell>
    )
  }
}
